const baseRoute = "/auth"

export const authRoutes = {
    LANDING: `/`,
    LOGIN: `${baseRoute}/login`,
    SIGNUP:  `${baseRoute}/signup`,
    VERIFY_ACCOUNT:  `${baseRoute}/account-verify`,
    RESET_PASSWORD: `${baseRoute}/reset-password`,
    FORGOT_PASSWORD: `${baseRoute}/forgot-password`,
}